import { render, staticRenderFns } from "./RootTemplate.vue?vue&type=template&id=2877ad2c&scoped=true"
import script from "./RootTemplate.vue?vue&type=script&lang=js"
export * from "./RootTemplate.vue?vue&type=script&lang=js"
import style0 from "./RootTemplate.vue?vue&type=style&index=0&id=2877ad2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2877ad2c",
  null
  
)

export default component.exports